import { useMemo } from 'react'
import { useAuth } from './useAuth'
import { useMyRequests, terminalMillis } from './useMyRequests'
import { useSeenWatermark } from './useSeenWatermark'

/**
 * Unread count for the profile nav badge: requests of the user's that were
 * addressed since they last had the My requests panel open. Watermark in
 * `users/{uid}/private/requestsSeen`.
 *
 * Pass `active` from the panel itself so opening it advances the watermark;
 * every other caller passes false and just reads the count. Guests get 0 —
 * `signedInUid` is null for anonymous users and they can't submit anything.
 */
export function useRequestsUnread(active: boolean): number {
  const { signedInUid } = useAuth()
  const { items, loading } = useMyRequests(signedInUid)
  const times = useMemo(
    () => items.map(terminalMillis).filter((t): t is number => t !== null),
    [items],
  )
  return useSeenWatermark({
    uid: signedInUid,
    docName: 'requestsSeen',
    times,
    active,
    itemsLoading: loading,
    logTag: 'requests',
  }).unread
}
